import ConsultaBase from "../shared/ConsultaBase";
import { optichiller1CompCT6ConsultaConfig } from "../config/optichiller1compct6Consulta";

const COptichiller1CompCT6 = () => {
  return <ConsultaBase config={optichiller1CompCT6ConsultaConfig} />;
};

export default COptichiller1CompCT6;  